module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Da-Ef.54027048.png";